import { createServer } from "miragejs"
import { seed } from "./seeder";
import { initWebsocketServer } from "./websocketServer";

/* * This file initializes a Mirage server for offline mode.
 * The server is used to mock API responses for development and testing purposes.
 * It allows developers to work without needing a live backend service.
 */
window.offlineServerInstance = null;

/** * Initializes the Mirage server for offline mode.
 * This function checks if the server is already running,
 * and if not, it creates a new Mirage server instance.
 * It also sets up the XMLHttpRequest to avoid issues with the onloadend event.
 * The server is seeded with stub data for offline functionality.
 * @returns {void}
 */ 
const initOfflineServer = () => {
    
    // Check if the Mirage server instance is already initialized
    if (!window.offlineServerInstance) {
        console.log("Initializing Mirage server for demo mode");
        /* Create a new Mirage server instance
        * This will mock API responses based on the provided seed data
        * and allow the application to function in offline mode.
        */
        window.offlineServerInstance = createServer({
            routes() {
                /*
                This is a workaround to avoid the onloadend event being triggered
                when using XMLHttpRequest in the Mirage server.
                This is necessary because some libraries (like axios) rely on this event
                to handle the response, and Mirage's XMLHttpRequest implementation
                does not support it.
                */
                const NativeXMLHttpRequest = window.XMLHttpRequest;

                window.XMLHttpRequest = function XMLHttpRequest() {
                    const request = new NativeXMLHttpRequest(arguments);
                    delete request.onloadend;
                    return request;
                };
                seed(this)
            },
        })
        initWebsocketServer();
        console.log("Mirage server initialized successfully");
    } else {
        console.log("Mirage server already running");
    }
}

/** * Shuts down the Mirage server if it is running.
 * This function sets the server instance to null after shutdown,
 * allowing for a clean state for future initializations.
 * @returns {void}
 */
const shutdownOfflineServer = () => {
    if (window.offlineServerInstance) {
        console.log("Shutting down Mirage server");
        window.offlineServerInstance.shutdown();
        window.offlineServerInstance = null;
        console.log("Mirage server shut down successfully");
    }
}

/** * Checks if the Mirage server is currently running.
 * This function returns true if the server instance is not null,
 * indicating that the server is active and can handle requests.
 * @returns {boolean}
 */
const isOfflineServerRunning = () => {
    return ![null, undefined].includes(window.offlineServerInstance);
}

export { initOfflineServer, shutdownOfflineServer, isOfflineServerRunning }